import Script from 'next/script';
const OfflineTryAgain = () => {
  return <Script id="offlinePageTryAgain" strategy="beforeInteractive" defer data-sentry-element="Script" data-sentry-component="OfflineTryAgain" data-sentry-source-file="OfflineTryAgain.tsx">
      {`window.onload = function() {
            const offlinePageTryAgainBtn = document.querySelector('#offlinePageTryAgainBtn');
            if(offlinePageTryAgainBtn){
              offlinePageTryAgainBtn.addEventListener('click', function() {
                window.location.reload()
              });
            }
          };`}
    </Script>;
};
export default OfflineTryAgain;